// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"308":"2a3e1302","424":"e0a11fd5","462":"e345cd67","675":"4c897d96","935":"482a2ba8"}[chunkId] + ".js";
};